/*
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2021-12-06 17:18:37
 * @LastEditTime: 2021-12-06 17:36:29
 * @LastEditors: 赵大壮
 */
import { Component, Vue, Inject } from "vue-property-decorator";

@Component({
    components: { }
})
export default class Index extends Vue {

    created() {}

    mounted() {
        
    }
    
    beforeDestroy() {
        
    }
}